export default "/images/share.svg?d96338ca8214718d71ab3a32e47b2d89";